export const sortTypes = [
    {
        id: 'newest',
        title: 'Newest',
    },
    {
        id: 'priceDesc',
        title: 'Price high to low',
    },
    {
        id: 'priceAsc',
        title: 'Price low to high'
    }
];
